<template>
  <div class="page page-insurance">
    <section class="section">
      <div class="section-inner">
        <div class="section-header section-header--center">
          <h2 class="section-title">保险信息</h2>
          <p class="section-subtitle">分享保险行业信息及各保险公司的产品信息</p>
        </div>
        <div class="news-list">
          <article
            v-for="item in news"
            :key="item.id"
            class="news-card"
            @click="goDetail(item.id)"
          >
            <div class="thumb-wrapper">
              <img :src="item.cover || 'https://picsum.photos/420/240?random=' + item.id" :alt="item.title">
            </div>
            <div class="news-content">
              <h3 class="news-title">{{ item.title }}</h3>
              <div class="news-meta">
                <span>{{ item.date }}</span>
                <span>· {{ item.author }}</span>
                <span>· 阅读量：{{ readCount(item.id) }}</span>
              </div>
              <p class="news-summary">{{ item.summary }}</p>
            </div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InsurancePage',
  computed: {
    ...mapGetters(['getInsuranceList', 'getInsuranceReadCount']),
    news() {
      return this.getInsuranceList
    }
  },
  methods: {
    goDetail(id) {
      this.$router.push(`/insurance/${id}`)
    },
    readCount(id) {
      return this.getInsuranceReadCount(id)
    }
  }
}
</script>

<style scoped>
.page {
  background: #f5f7fa;
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.news-card {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 18px;
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 14px 38px rgba(15, 23, 42, 0.12);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease;
}

.news-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 50px rgba(15, 23, 42, 0.18);
  background-color: #f9fafb;
}

.thumb-wrapper img {
  width: 100%;
  height: 180px;
  object-fit: cover;
}

.news-content {
  padding: 16px 18px 18px;
}

.news-title {
  font-size: 18px;
  color: #102a43;
  margin-bottom: 6px;
}

.news-meta {
  font-size: 12px;
  color: #9fb3c8;
  margin-bottom: 8px;
}

.news-summary {
  font-size: 14px;
  color: #52606d;
  line-height: 1.8;
}

.section-header--center {
  text-align: center;
}

@media (max-width: 768px) {
  .news-card {
    grid-template-columns: 1fr;
  }
  .thumb-wrapper img {
    height: 160px;
  }
}
</style>
